import ImageSourceDirective from './image-source.directive.js';
import HelperFactory from './helper.factory.js';
import QueryComponent from './query.component';
import PaginationComponent from './pagination.component';
import LazyElementComponent from './lazy-element.component';
import CompileComponent from './compile.component';
import GetCropUrlFilter from './get-crop-url.filter';
import TrustAsMarkupFilter from './trust-as-markup.filter.js';
import StripParagraphsFilter from './strip-paragraphs.filter.js';
import FitTextDirective from './fit-text.directive.js';
import ToNumArrayFilter from './to-num-array.js';
import AttrsDirective from './attrs.directive';
import JoinFilter from './join.filter';
import ArrayFilter from './arrayFilter.filter';
export default function Utility(module) {
    JoinFilter(module);
    TrustAsMarkupFilter(module);
    ToNumArrayFilter(module);
    HelperFactory(module);
    ImageSourceDirective(module);
    QueryComponent(module);
    PaginationComponent(module);
    LazyElementComponent(module);
    CompileComponent(module);
    GetCropUrlFilter(module);
    StripParagraphsFilter(module);
    FitTextDirective(module);
    AttrsDirective(module);
    ArrayFilter(module);
};